<template>
  <div class="flex justify-center">
    <button @click.stop="show = !show" class="text-gray-800 focus:outline-none">
      <svg
        class="w-6 fill-current cursor-pointer text-gray-800 hover:text-gray-500"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M4 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
        />
      </svg>
    </button>
    <div
      v-if="show"
      @click.stop="show = false"
      class="fixed top-0 right-0 w-full h-full flex items-center justify-center bg-gray-800 bg-opacity-50 z-40"
    >
      <ul
        @mouseleave="show = false"
        class="bg-white rounded border border-gray-200 text-sm shadow"
      >
        <li
          v-for="(option, index) in currentTab.options"
          :key="index"
          class="block hover:bg-gray-200"
        >
          <a
            v-if="option.type === 'anchor'"
            :href="option.href"
            @click.stop=""
            class="block p-4 text-center"
            >{{ option.title }}</a
          >
          <button
            v-else-if="option.type === 'function'"
            @click.stop="option.function(entry)"
            class="w-full p-4"
          >
            {{ option.title }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    entry: {
      type: Object,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters(["currentTab"]),
  },
};
</script>
